<!-- <p>Value:
<input type="number" [(ngModel)]="value">
</p> -->

<div [formGroup]="parent" class="col-sm-12 form-field has-error"
  [ngClass]="{'content-wrapper':!defaultStyle,'clear-all':defaultStyle, 'opacity':(!enableTooltip ? disable : false), 'pointer-events-none':(!enableTooltip ? disable : false)}">
  @if (sliderConfig.sliderTitleVisible) {
    <p class="margint-8"
      [ngClass]="{'form-label-fullwidth':defaultStyle, 'opacity':disable}" [innerHTML]="sliderConfig.sliderTitle"
    [id]="sliderId+'-header'"></p>
  }
  <div
    [ngClass]="{'margint-30':(sliderConfig.sliderTitleVisible || sliderConfig.sliderType === 'Months' || !(sliderConfig.sliderTitleVisible))}"
    class="row">
    <div class="row flex-container w-300">
      <div class="margin-top-3 text-center right-pad-0">
        @if (sliderConfig.sliderTypeVisible) {
          <span [ngClass]="{'opacity':disable}" class="standfirst font-18"
            [id]="sliderId+sliderConfig.sliderType">
            <span>{{sliderConfig.sliderType}}{{(!sliderConfig.unselectedByDefault)? ':&thinsp;':''}}</span>
            @if (!sliderConfig.unselectedByDefault) {
              <i [id]="sliderId+'-value'">{{calculatedValueLumpSum}}</i>
            }
            <!-- {{sliderConfig.sliderType==='Percentage'?'%':null}} -->
          </span>
        }

      </div>
      @if (sliderConfig.infoIconFlag) {
        <div class="col-md-2 left-pad-0">
          <app-tool-tip-notification [childId]="sliderId" [tooltipName]="controlName+'_tooltip'" class="col-sm-1"
            [disable]="!enableTooltip ? disable : false" [tooltipData]="sliderConfig.infoIconData"
            (goToDependatsTTEmitter)="goToDependantsPageSS()"
          (displayMobileTooltipEmitter)="displayMobileTooltipSliderReceiver()"></app-tool-tip-notification>
        </div>
      }
    </div>
    <div
      [ngClass]="{'custom-slider-default': sliderConfig.unselectedByDefault, 'custom-slider': !sliderConfig.unselectedByDefault}">
      <!-- <ng5-slider [ngClass]="{'opacity':disable}" [id]="sliderId" (userChange)="calculate(value,sliderConfig)"
      class="margin-top-30" [(value)]="value" [options]="options" [formControlName]="controlName"
    (userChangeEnd)="onUserChangeEnd($event, sliderConfig, controlName)"></ng5-slider> -->
    <ngx-slider [ngClass]="{'opacity':disable}" [id]="sliderId" (userChange)="calculate(value,sliderConfig)"
      class="margin-top-30" [(value)]="value" [options]="options" [formControlName]="controlName"
    (userChangeEnd)="onUserChangeEnd($event, sliderConfig, controlName)"></ngx-slider>
  </div>
  <ng-content select=".textUnderSlider" style="margin-top: 40px;">

  </ng-content>
  <div class="row">
    @if (parent.get(controlName).touched
      &&
      parent.get(controlName).errors && (parent.get(controlName).errors.customErrorMessage || parent.get(controlName).errors.zeroAmount || sliderConfig.unselectedByDefault
      || parent.get(controlName).errors.invalidLTAMin)) {
      <div [id]="controlName+'-error'" class="col-md-12 form-validation-error margin-top-40 width-100">
        <i class="icon icon-error" aria-hidden="true"></i>
        @if (sliderConfig.unselectedByDefault) {
          <p>{{sliderConfig.validationMsg}}
          </p>
        }
        @if (parent.get(controlName).errors.zeroAmount) {
          <p>{{sliderConfig.zeroValidationMsg}}
          </p>
        }
        @if (parent.get(controlName).errors.customErrorMessage) {
          <p>{{sliderConfig.customErrorMessage}}
          </p>
        }
        @if (parent.get(controlName).errors.invalidLTAMin) {
          <p>{{setMinLTA(sliderConfig.invalidLTAMinMsg)}}
          </p>
        }
      </div>
    }
  </div>
  <!-- <app-tool-tip-notification [tooltipName]="controlName+'_tooltip'" *ngIf="questionConfig.infoIconFlag" class="col-sm-1" [tooltipData]="questionConfig.infoIconData"></app-tool-tip-notification> -->
</div>

<!-- <div *ngIf="questionInfo && questionInfo !== ''" class="question-info col-md-12 p-0 margin-top-error" [ngClass]="questionInfoClass">
<p [innerHTML]="questionInfo"></p>
</div> -->
</div>